import * as JsPDF from "jspdf";

export const createPdf = {
  methods: {
    pdf () {
      if (!this.selected.length ) {
        this.$vs.notify({
          title:'Error',
          text:'No document to generate pdf',
          color:'danger'
        })
        return
      }
      var data = this.selected
      this.selected = []
      var coverSheets = new JsPDF({
        orientation: 'portrait',
        format: 'a4'
      })
      var x = 20
      var yRef = 62
      var yDateSentToStorage = 67
      var yBusinessName = 72
      var yUserName = 77

      for (var i = 0; i < data.length; i++) {

        var personDescription = data[i].will ? 'Testator' : 'Person'

        coverSheets.setFontSize(12)
        coverSheets.setFontStyle('bold')
        coverSheets.text('Ref : ' + data[i].storage_id + '  ' + data[i].reference_number, x, yRef)
        coverSheets.setFontSize(9)
        coverSheets.setFontStyle('normal')
        coverSheets.text('Date Sent : ' + this.formatDateAndTime(data[i].date_created), x, yDateSentToStorage)
        coverSheets.text('Firm : ' + data[i].business.name, x, yBusinessName)
        coverSheets.text(personDescription + ' : ' + data[i].user.user_detail.full_name + ', ' + data[i].user.user_detail.post_code, x, yUserName)

        if (i !== data.length - 1) coverSheets.addPage('a4', 'portrait')
      }
      coverSheets.save('to_send_to_storage_recent.pdf')
      this.$vs.loading.close("#loading-container > .con-vs-loading")
    },
  }
}
